<script setup>

    import Multiselect from 'vue-multiselect'
    const modelValue = defineModel()
    const commercialStore = useCommercialStore()

    const { items } = defineProps({
        items: Array
    })  

    const emit = defineEmits('onUpdate')

    // watch( commercialStore.filter.sort, () => {
    //     console.log('sort', commercialStore.filter.sort);
    // }, { deep: true })

</script>
<template>
    <div>        
        <multiselect 
            class="light"
            v-model="modelValue"
            :options="items" 
            :allowEmpty="false" 
            :searchable="false" 
            :show-labels="false"
            @update:modelValue="emit('onUpdate')"
            label="label"
            :preselectFirst="true" 
            track-by="id"
            placeholder="Сортировка" 
        />
    </div>
</template>
